import { PaginationData } from '~core/models/core.models';
import {
  FreeRequestParams,
  Resource,
  ResourceSelectionMode
} from '~core/models/shared.models';
import { GetResourceDataParams } from '~backoffice/app/~shared/models/store-actions.models';
import { ResourceStateModel } from '~backoffice/app/~shared/models/store.models';

export class ResetState {
  static readonly type = '[Resource] Reset State';
  constructor(public data?: Partial<ResourceStateModel>) {}
}

export class PatchItem {
  static readonly type = '[Resource] Patch Item';
  constructor(
    public data: {
      item: Resource;
      newData: Partial<Resource>;
      path?: string;
    }
  ) {}
}

export class ToggleItemSelection {
  static readonly type = '[Resource] Toggle Item Selection"';
  constructor(public data: Resource) {}
}

export class ToggleItemsSelection {
  static readonly type = '[Resource] Toggle Items Selection';
  constructor(public data?: ResourceSelectionMode) {}
}

export class ToggleDisposition {
  static readonly type = '[Resource] Toggle Disposition';
}

export class ApplyFilters {
  static readonly type = '[Resource] Apply Filters';
  constructor(public data: FreeRequestParams) {}
}

export class ResetFilters {
  static readonly type = '[Resource] Reset Filters';
  constructor(public data?: FreeRequestParams) {}
}

export class SetPagination {
  static readonly type = '[Resource] Set Pagination';
  constructor(public data?: PaginationData) {}
}

export class GetData {
  static readonly type = '[Resource] Get Data';
  constructor(public data?: GetResourceDataParams) {}
}

export class LoadMore {
  static readonly type = '[Resource] Load More';
}

export class NavigateCursor {
  static readonly type = '[Resource] Navigate Cursor';
  constructor(public data: 'next' | 'previous') {}
}

export class RemoveItem {
  static readonly type = '[Resource] Remove Item';
  constructor(public data: { id: string }) {}
}
